import { useQuery } from "react-query";

import { useHonoClient } from "~/hooks/HonoContext";
import { useCurrentAccount } from "~/hooks/useCurrentAccount";

export const useGetObjectAccessToken = ({ enabled }: { enabled: boolean }) => {
  const { hc } = useHonoClient();
  const { id } = useCurrentAccount();

  return useQuery({
    queryFn: () =>
      hc.accounts[":accountId"].object.accessToken
        .$get({
          param: {
            accountId: id,
          },
        })
        .then((res) => res.json()),
    queryKey: "objectAccessToken",
    enabled,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchInterval: 1000 * 60,
    staleTime: 1000 * 60,
  });
};
